















import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';

import type { Product } from '~/modules/catalog/product/types';

export default defineComponent({
  name: 'VaimoCrossSellProducts',
  components: {
    VaimoCrossSellProduct: () => import('./VaimoCrossSellProduct.vue')
  },
  props: {
    products: {
      required: true,
      type: Array as PropType<Product[]>
    },
    title: {
      required: false,
      default: '',
      type: String
    }
  },
  setup(props) {
    const sortedProducts = computed<Product[]>(() =>
      [...props.products].sort(
        (a, b) => Number(a.position) - Number(b.position)
      )
    );

    return {
      sortedProducts
    };
  }
});
